require('angular');
require('angular-cookies');
require('angular-route');
require('angular-animate');
require('angular-sanitize');
require('angular-messages');
require('angular-aria');
require('angular-material');
require('angular.piechart')
require('chart.js');
require('angular-chart.js');
var moment = require('moment');
var ngTimePicker = require('angular-material-time-picker');

import authenticationController from './components/auth/auth.controller';
import accountController from './components/account/account.controller';
import clientAddController from './components/clients/clients.add.controller';
import clientEditController from './components/clients/clients.edit.controller';
import clientListController from './components/clients/clients.list.controller';
import clientEventListController from './components/clients/clients.event-list.controller';
import clientUserListController from './components/clients/clients.user-list.controller';
import eventAddController from './components/events/events.add.controller';
import eventEditController from './components/events/events.add.controller';
import eventViewController from './components/events/events.view.controller';
import eventsListController from './components/events/events.list.controller';
import exerciseAddController from './components/exercise/exercise.add.controller';
import exerciseEditController from './components/exercise/exercise.edit.controller';
import exerciseNewPostController from './components/exercise/exercise.newpost.controller';
import exerciseController from './components/exercise/exercise.controller';
import navigationController from './components/navigation/navigation.controller';
import mainController from './components/main/main.controller';
import userAddController from './components/users/users.add.controller';
import userEditController from './components/users/users.edit.controller';
import trainerAddController from './components/trainers/trainers.add.controller';
import trainerEditController from './components/trainers/trainers.edit.controller';
import traineeAddController from './components/trainees/trainees.add.controller';
import traineeEditController from './components/trainees/trainees.edit.controller';
import channelsAddController from './components/channels/channels.add.controller';
import channelsEditController from './components/channels/channels.edit.controller';
import subscriptionListController from './components/subscriptions/subscriptions.list.controller';
import subscriptionAddController from './components/subscriptions/subscriptions.add.controller';
import subscriptionEditController from './components/subscriptions/subscriptions.edit.controller';
import creditsListController from './components/credits/credits.list.controller';

import authenticationService from './services/authentication.service';
import channelsService from './services/channels.service';
import clientService from './services/client.service';
import exerciseService from './services/exercise.service';
import exerciseHubService from './services/exercise.hub.service';
import eventService from './services/event.service';
import subscriptionsService from './services/subscription.service';
import notificationsService from './services/notifications.service';
import userService from './services/user.service';
import fileService from './services/file.service';
import auditService from './services/audit.service';

var app = angular.module('splutter', [
  'ngRoute',
  'ngCookies',
  'ngMaterial',
  'ngSanitize',
  ngTimePicker,
  'piechart',
  'chart.js'
]);

app.config(function($mdDateLocaleProvider) {
  $mdDateLocaleProvider.formatDate = function(date) {
    return date ? moment(date).format('DD-MM-YYYY') : '';
  };
  
  $mdDateLocaleProvider.parseDate = function(dateString) {
    var m = moment(dateString, 'DD-MM-YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };
});

app.config(function($mdThemingProvider) {
  var redMap = $mdThemingProvider.extendPalette('red', {
    '500': '#de2130',
    'contrastDefaultColor': 'light'
  });
  $mdThemingProvider.definePalette('red', redMap);
  $mdThemingProvider.theme('default')
    .primaryPalette('red')
    .accentPalette('grey');
});

app.config(['$routeProvider', function ($routeProvider) {
  $routeProvider
    .when('/', {
      templateUrl: 'views/components/main/main.html',
      controller: 'mainController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/login', {
      templateUrl: 'views/components/auth/login.html',
      controller: 'authenticationController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: false,
        loginRedirect: false
      }
    })
    .when('/account', {
      templateUrl: 'views/components/account/account.html',
      controller: 'accountController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/exercise/:id', {
      templateUrl: 'views/components/exercise/exercise.html',
      controller: 'exerciseController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/add', {
      templateUrl: 'views/components/clients/client-add.html',
      controller: 'clientAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/edit/:id', {
      templateUrl: 'views/components/clients/client-edit.html',
      controller: 'clientEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/users/edit/:id', {
      templateUrl: 'views/components/users/users.edit.html',
      controller: 'usersEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/users/add', {
      templateUrl: 'views/components/users/users.add.html',
      controller: 'usersAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/trainers/add', {
      templateUrl: 'views/components/trainers/trainers.add.html',
      controller: 'trainersAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/trainers/add', {
      templateUrl: 'views/components/trainers/trainers.add.html',
      controller: 'trainersAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/trainers/edit/:id', {
      templateUrl: 'views/components/trainers/trainers.edit.html',
      controller: 'trainersEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/trainees/add', {
      templateUrl: 'views/components/trainees/trainees.add.html',
      controller: 'traineesAddController',
      controllerAs: 'ctrl', 
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/trainees/edit/:id', {
      templateUrl: 'views/components/trainees/trainees.edit.html',
      controller: 'traineesEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/user/edit/:id', {
      templateUrl: 'views/components/users/users.edit.html',
      controller: 'usersEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/events/add', {
      templateUrl: 'views/components/events/events.add.html',
      controller: 'eventAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/events/view/:eventId', {
      templateUrl: 'views/components/events/events.view.html',
      controller: 'eventViewController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/events/view/:eventId/exercise/add', {
      templateUrl: 'views/components/exercise/exercise.add.html',
      controller: 'exerciseAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/clients/:clientId/events/:eventId/exercises/:exerciseId', {
      templateUrl: 'views/components/exercise/exercise.edit.html',
      controller: 'exerciseEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage', {
      templateUrl: 'views/components/clients/client-list.html',
      controller: 'clientListController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/credits', {
      templateUrl: 'views/components/credits/credits-list.html',
      controller: 'creditsListController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/credits/:subscriptionId', {
      templateUrl: 'views/components/credits/credits-list.html',
      controller: 'creditsListController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/channels/add', {
      templateUrl: 'views/components/channels/channels.add.html',
      controller: 'channelsAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/channels/:id', {
      templateUrl: 'views/components/channels/channels.edit.html',
      controller: 'channelsEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/subscriptions', {
      templateUrl: 'views/components/subscriptions/subscription-list.html',
      controller: 'subscriptionListController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/subscriptions/add', {
      templateUrl: 'views/components/subscriptions/subscription-add.html',
      controller: 'subscriptionAddController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .when('/manage/subscriptions/edit/:id', {
      templateUrl: 'views/components/subscriptions/subscription-edit.html',
      controller: 'subscriptionEditController',
      controllerAs: 'ctrl',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    })
    .otherwise({
      redirectTo: '/',
      restrictions: {
        ensureAuthenticated: true,
        loginRedirect: false
      }
    });
}]).factory('authHttpResponseInterceptor',['$q','$location',function($q,$location){
	return {
		response: function(response){
			if (response.status === 401) {
				console.log("Response 401");
			}
			return response || $q.when(response);
		},
		responseError: function(rejection) {
			if (rejection.status === 401) {
				console.log("Response Error 401",rejection);
				$location.path('/login').search('returnTo', $location.path());
			}
			return $q.reject(rejection);
		}
	}
}])
.config(['$httpProvider',function($httpProvider) {
	//Http Intercpetor to check auth failures for xhr requests
	$httpProvider.interceptors.push('authHttpResponseInterceptor');
}]);

app.run(function routeStart($rootScope, $location, $route, $cookies) {
  $rootScope.$on('$routeChangeStart', (event, next, current) => {
    if (next.restrictions.ensureAuthenticated) {
      if (!localStorage.getItem('token')) {
        $location.path('/login');
      }
    }
    if (next.restrictions.loginRedirect) {
      if (!localStorage.getItem('token')) {
        $location.path('/status');
      }
    }
  });
});

(function() {
  var env = "prod";  // dev|stage|prod
  var urls = {};
  if(env === "dev")
  {
    urls = {  
      ApiBaseUrl: "https://localhost:35393", 
      SignalRBaseUrl: "https://localhost:37030",
      BlobBaseUrl: "https://splutterstagingapp.blob.core.windows.net"
    };
  }
  else if(env === "stage")
  {
    urls = {  
      ApiBaseUrl: "https://splutter-api-staging.azurewebsites.net", 
      SignalRBaseUrl: "https://splutter-hub-staging.azurewebsites.net",
      BlobBaseUrl: "https://splutterstagingapp.blob.core.windows.net"
    };
  }
  else
  {
    urls = {  
      ApiBaseUrl: "https://splutter-api-live.azurewebsites.net", 
      SignalRBaseUrl: "https://splutter-hub-live.azurewebsites.net",
      BlobBaseUrl: "https://splutterapp.blob.core.windows.net"
    };
  }
  app.constant('globalConstants', urls);
})();

app.controller('authenticationController', ['$location', 'authenticationService', authenticationController]);

app.controller('accountController', ['userService', accountController]);

app.controller('clientAddController', ['$location', "$window", 'clientService', clientAddController]);

app.controller('clientEditController', ['$scope', '$location', '$routeParams', '$route', '$window', '$mdDialog','clientService', 'userService', 'authenticationService', 'notificationsService', 'globalConstants', clientEditController]);

app.controller('clientListController', ['clientService', 'userService', 'authenticationService', 'channelsService', '$location', 'globalConstants', clientListController]);

app.controller('eventAddController', ['$routeParams', '$location', '$window', 'eventService', eventAddController]);

app.controller('eventViewController', ['$routeParams', '$location', '$route', 'eventService', 'exerciseService','userService', 'authenticationService', 'channelsService', '$mdDialog', 'notificationsService', 'globalConstants', eventViewController]);

app.controller('clientEventListController', ['$routeParams', 'eventService', 'clientService', clientEventListController]);

app.controller('clientUserListController', ['$scope', '$routeParams', 'userService', 'clientService', 'globalConstants', clientUserListController]);

app.controller('mainController', ['$scope', '$location', 'exerciseService', 'eventService', 'globalConstants', 'authenticationService', mainController]);

app.controller('navigationController', ['$scope', '$location', 'userService', 'authenticationService', '$routeParams', navigationController]);

app.controller('eventListController', ['userService', 'eventsService', '$window'], eventsListController);

app.controller('exerciseAddController', ['$routeParams', '$location', 'exerciseService', 'notificationsService', exerciseAddController]);

app.controller('exerciseEditController', ['$location', '$routeParams', '$mdDialog', 'exerciseService', 'notificationsService', 'globalConstants', exerciseEditController]);

app.controller('exerciseController', ['$rootScope', '$scope', '$routeParams', '$mdDialog', '$location', 'exerciseService', 'exerciseHubService','channelsService', 'authenticationService', 'globalConstants', 'userService', 'notificationsService', exerciseController]);

app.controller('exerciseNewPostController', ['$scope', '$rootScope', '$routeParams', 'userService', 'authenticationService', '$mdToast', 'globalConstants', 'exerciseService', exerciseNewPostController]);

app.controller('usersAddController', ['$routeParams', '$location','$window', 'userService', userAddController]); 

app.controller('usersEditController', ['$routeParams', '$window', '$mdDialog', 'userService', userEditController])

app.controller('trainersAddController', ['$routeParams', '$location', 'userService', 'notificationsService', 'globalConstants', trainerAddController]); 

app.controller('trainersEditController', ['$routeParams', '$location', '$mdDialog', 'userService', 'notificationsService', 'globalConstants', trainerEditController])

app.controller('traineesAddController', ['$routeParams', '$location', 'userService', 'notificationsService', 'globalConstants', traineeAddController]); 

app.controller('traineesEditController', ['$routeParams', '$location', '$mdDialog', 'userService', 'notificationsService', 'globalConstants', traineeEditController])

app.controller('channelsAddController', ['$scope', '$routeParams', '$location', 'channelsService', 'notificationsService', 'authenticationService', 'globalConstants', channelsAddController]); 

app.controller('channelsEditController', ['$scope', '$routeParams', '$location', 'channelsService', 'authenticationService', '$mdDialog', 'notificationsService', 'globalConstants', channelsEditController])

app.controller('subscriptionListController', ['clientService', 'userService', 'channelsService', 'subscriptionsService', '$location', subscriptionListController]);

app.controller('subscriptionAddController', ['userService', '$location', 'notificationsService', subscriptionAddController]);

app.controller('subscriptionEditController', ['$routeParams','userService', 'subscriptionsService', '$mdDialog', '$location', 'notificationsService', 'auditService', subscriptionEditController]);

app.controller('creditsListController', ['$routeParams','auditService', 'subscriptionsService', '$window', creditsListController]);

app.service('authenticationService', ['$http','globalConstants', '$location', authenticationService]);

app.service('channelsService', ['$http', 'authenticationService', 'globalConstants', channelsService]);

app.service('clientService', ['$http', 'authenticationService', 'globalConstants', clientService]);

app.service('exerciseService', ['$http', 'authenticationService','globalConstants', exerciseService]);

app.service('exerciseHubService', ['$rootScope', 'globalConstants', exerciseHubService]);

app.service('eventService', ['$http', 'authenticationService', 'globalConstants', eventService]);

app.service('subscriptionsService', ['$http', 'authenticationService', 'globalConstants', subscriptionsService]);

app.service('notificationsService', ['$mdToast', notificationsService]);

app.service('userService', ['$http', 'authenticationService', 'globalConstants', userService]);
app.service('fileService', ['$http', 'authenticationService', 'globalConstants', fileService]);
app.service('auditService', ['$http', 'authenticationService', 'globalConstants', auditService]);

app.filter('sumBy', function () {
  return function (data, key) {
    if (!Array.isArray(data)) return 0;
    return data.reduce((sum, item) => sum + (item[key] || 0), 0);
  };
});

app.filter('numberpad', function() {
  return function(input, places) {
    var out = "";
    if (places) {
      var placesLength = parseInt(places, 10);
      var inputLength = input.toString().length;
    
      for (var i = 0; i < (placesLength - inputLength); i++) {
        out = '0' + out;
      }
      out = out + input;
    }
    return out;
  };
});  

app.filter('zpad', function() {
	return function(input, n) {
		if(input === undefined)
			input = ""
		if(input.length >= n)
			return input
		var zeros = "0".repeat(n);
		return (zeros + input).slice(-1 * n)
	};
});

app.filter("nl2br", function($filter) {
  return function(data) {
    if (!data) return data;
    return data.replace(/\n\r?/g, '<br />');
  };
 });

app.filter('parseUrl', function() {
    var urls = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim
    var emails = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim

    return function(text) {        
        if(text.match(urls)) {
            text = text.replace(urls, "<a href=\"$1\" target=\"_blank\">$1</a>")
        }
        if(text.match(emails)) {
            text = text.replace(emails, "<a href=\"mailto:$1\">$1</a>")
        }

        return text       
    }
})

app.filter('htmlEncode', function() {
  return function(text) {        
      if(text) {
        var tempElement = document.createElement('div');
        tempElement.textContent = text;
        text = tempElement.innerHTML;
        tempElement = null;
      }
      return text       
  }
})

app.directive('timer', function($interval) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      control: '=',
      seconds: '=',
      minutes: '=',
      hours: '=',
      clockBase: '=',
      clock: '=?',
    },
    link: function(scope, element) {
      var intervalId;
      var d1 = null;
      scope.internalControl = scope.control || {};
      scope.running = false;

      scope.internalControl.refresh = function(){
        updateClock();
      };

      scope.internalControl.stop = function() {
        $interval.cancel(intervalId);
        scope.running = false;
      };
      
      scope.internalControl.start = function() {
        d1 = new Date();
        updateClock();
        intervalId = $interval(ping, 30);
        scope.running = true;
      };
          
      function ping() {
        var d2 = new Date();
        var durationInMilliseconds = d2.getTime() - d1.getTime();
        //console.log("ping::durationInMilliseconds="+durationInMilliseconds);
        if(durationInMilliseconds >= 1000) {
          d1 = d2;
          updateDuration();
          updateClock();
        }
      }
      
      function updateDuration() {
        scope.seconds++;
        if (scope.seconds === 60) {
          scope.seconds = 0;
          scope.minutes++;
        }
        if(scope.minutes === 60) {
          scope.minutes = 0;
          scope.hours++;
        }
      }

      function updateClock() {
        if(scope.clockBase) {
          var date = new Date(scope.clockBase);
          //console.log("date: "+date);
          var durationInMilliseconds = (scope.hours * 3600 + scope.minutes * 60 + scope.seconds) * 1000;
          date.setTime(date.getTime() + durationInMilliseconds);
          
          var h = date.getHours().toString().padStart(2, '0');
          var m = date.getMinutes().toString().padStart(2, '0');
          var s = date.getSeconds().toString().padStart(2, '0');
  
          var ampm = h >= 12 ? 'PM' : 'AM';
          h = h % 12;
          h = h ? h : 12;
  
          var formattedTime = h + ':' + m + ' ' + ampm;
          scope.clock = formattedTime;
          //console.log("clock: "+formattedTime);
        }
      }
    },
    template:
      '<div class="timer">' +
        '<h3 style="margin-bottom:0;">Elapsed time</h3>' +
        '<div>{{hours|numberpad:2}}:{{minutes|numberpad:2}}:{{seconds|numberpad:2}}</div>' +
        '<div ng-if="clock"><h4 style="margin-bottom:0; margin-top:10px">Exercise time</h4>' +
        '<div>{{clock}}</div></div>' +
      '</div>',
    replace: true
  };
});


app.directive("mainNavigation", function () {
  return {
    restrict: 'E',
    controller: 'navigationController',
    controllerAs: 'ctrl',
    templateUrl: 'views/components/navigation/navigation.html',
    transclude: true,
    replace: true
  };
});

app.directive("exerciseNewPost", function () {
  return {
    restrict: 'E',
    controller: 'exerciseNewPostController',
    controllerAs: 'ctrl',
    scope: {
      exerciseId: '=',
      exerciseHubService: '=',
      message: '=',
      avatar: '=',
      activeTab: '=',
    },
    templateUrl: 'views/components/exercise/exercise.newpost.html',
    transclude: true,
    replace: true
  };
});

app.directive('file', function() {
  return {
      require:"ngModel",
      restrict: 'A',
      link: function($scope, el, attrs, ngModel){
          el.bind('change', function(event){
              var files = event.target.files;
              var file = files[0];
              
              var data = {};
              
              if(file.size/11264/11264 > 1)
              {
                data.filesizeError = true;
              }
              if(file.type != "image/jpeg" && file.type != "image/png")
              {
                data.filetypeError = true;
              }
              
              if(data.filesizeError || data.filetypeError)
              {
                alert("maximum file size 11MB");
                $scope.image = "";
              }
              else
              {
                GetFileString(file).then(function(data){
                  if(data)
                  {
                    ngModel.$setViewValue(data);
                  }
              });
            }              

              $scope.$apply();
          
      function GetFileString(f) {
        return new Promise(function(resolve, reject) {
            var r = new FileReader();
            var data = {};
            if(!f){
                resolve(data);
            }
            var mimetype = f.type;

            r.onloadend = function(e) {
                var image = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));

                data.imagetype = mimetype;
                data.image = image;
                
                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
      };
    });
  }
};
});


app.directive('planfile', function() {
  return {
      require:"ngModel",
      restrict: 'A',
      link: function($scope, el, attrs, ngModel){
          el.bind('change', function(event){
              var files = event.target.files;
              var file = files[0];
              
              var data = {};
              
              if(file.size/1024/1024 > 10)
              {
                data.filesizeError = true;
                ngModel.$setViewValue(data);
              }
              else
              {

                GetPlanFileString(file).then(function(data){
                if(data)
                {
                  console.log(data);
                  ngModel.$setViewValue(data);
                }
              });
            }              

              $scope.$apply();
          
      function GetPlanFileString(f) {
        return new Promise(function (resolve, reject) {
              var r = new FileReader();
              var data = {};
              if(!f){
                  resolve(data);
              }

          var mimetype = f.type;

          r.onloadend = function (e) {
              var doc = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                  return data + String.fromCharCode(byte);
              }, ''));
              data.doc = doc;
              data.mimetype = mimetype;
              data.fileextension = f.name.split('.').pop();
              data.filename = f.name;
              resolve(data);
          }
          r.readAsArrayBuffer(f);
      });
      };
    });
  }
};
});


angular.module('splutter').directive('postEmbed', ['$http', '$sce', ($http, $sce) => {
  return {
    restrict: 'A',
    scope: {
      postEmbed: '='
    },
    link: (scope, element, atts) => {
      scope.$watch('postEmbed', function() {
        var match = /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'> ]+)/g.exec(scope.postEmbed);
        if(match != null && match.length > 4)
        {
          element.html(
           `<iframe class="print-hide" src="https://www.youtube.com/embed/${match[5]}?autoplay=0&auto_play=false" width="640" height="360"></iframe>
            <span style="background: black !important; width:100%;display:inline-block;">
              <img style="margin:auto"  height="360" class="youtube-thumbnail printonly" src="https://i1.ytimg.com/vi/${match[5]}/0.jpg" alt="">
            </span>`)
        }

        var vimeoMatch = /vimeo.*(?:\/|clip_id=)([0-9a-z]*)/i.exec(scope.postEmbed);
        if(vimeoMatch != null) {
          var url = `http://vimeo.com/api/v2/video/${vimeoMatch[1]}.json`;
          var trustedUrl = $sce.trustAsResourceUrl(url);
          $http.jsonp(trustedUrl, {jsonpCallbackParam: 'callback'}).then((resp) => {
            element.html(
              `<iframe class="print-hide" src="https://player.vimeo.com/video/${vimeoMatch[1]}" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
              <span style="background: black !important; width:100%;display:inline-block;">
                <img style="margin:auto" height="360" class="youtube-thumbnail printonly" src="${resp.data[0].thumbnail_large}" alt="">
              </span>`);
          });
        }
      });
    }  
  }
}]);

angular.module('splutter').
directive('contenteditable', ['$sce', function($sce) {
  return {
    restrict: 'A', // only activate on element attribute
    require: '?ngModel', // get a hold of NgModelController
    link: function(scope, element, attrs, ngModel) {
      if (!ngModel) return; // do nothing if no ng-model

      // Specify how UI should be updated
      ngModel.$render = function() {
        render(ngModel.$viewValue);
      };

      function render(html) {
        element.html(html);
      }

      // Listen for change events to enable binding
      element.on('blur keyup change', function() {
        scope.$evalAsync(read);
      });
      read(); // initialize

      // Write data to the model
      function read() {
        var caretPosition = getCaretPosition(element[0]);
        var html = element.html();
        html = html.replace(/<[^>]+>/gm, '');

        // When we clear the content editable the browser leaves a <br> behind
        // If strip-br attribute is provided then we strip this out
        if ( attrs.stripBr && html == '<br>' ) {
          html = '';
        }
        
        html = html.replace(/(@[a-zA-Z0-9]{1,})/g, `<span>$1</span>`);
        html = html.replace(/(#[a-zA-Z0-9]{1,})/g, `<span>$1</span>`);

        ngModel.$setViewValue(html.replace(/<[^>]+>/gm, '').replace(/&nbsp;/g, ' '));
        render(html);
         
        setCaretPosition(element[0], caretPosition.range);
      }

      function getCaretPosition(editableDiv) {
        if (window.getSelection && window.getSelection().getRangeAt) {
                var range = window.getSelection().getRangeAt(0);
                var selectedObj = window.getSelection();
                var rangeCount = 0;
                var childNodes = selectedObj.anchorNode.parentNode.nodeName == "SPAN" ? 
                    selectedObj.anchorNode.parentNode.parentNode.childNodes : 
                    selectedObj.anchorNode.parentNode.childNodes;
                for (var i = 0; i < childNodes.length; i++) {
                    if (childNodes[i] == selectedObj.anchorNode || childNodes[i] == selectedObj.anchorNode.parentNode) {
                        break;
                    }
                    if (childNodes[i].outerHTML)
                        rangeCount += childNodes[i].innerText.length;
                    else if (childNodes[i].nodeType == 3) {
                        rangeCount += childNodes[i].textContent.length;                       
                    }
                }
                return { range: ( range.startOffset + rangeCount), anchor: selectedObj.anchorNode };
            }
        return { range: -1, anchor: editableDiv };
      }

      function setCaretPosition(el, pos){

        // Loop through all child nodes
        for(var node of el.childNodes){
            if(node.nodeType == 3){ // we have a text node
                if(node.length >= pos){
                    // finally add our range
                    var range = document.createRange(),
                        sel = window.getSelection();
                    range.setStart(node,pos);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                    return -1; // we are done
                }else{
                    pos -= node.length;
                }
            }else{
                pos = setCaretPosition(node,pos);
                if(pos == -1){
                    return -1; // no need to finish the for loop
                }
            }
        }
        return pos; // needed because of recursion stuff
      }
    }
  };
}]);

app.directive('file', function() {
    return {
        require:"ngModel",
        restrict: 'A',
        scope: {
          onChange: '&'
        },
        link: function($scope, el, attrs, ngModel){
            el.bind('change', function(event){
                var files = event.target.files;
                var file = files[0];

                ngModel.$setViewValue(file);
                $scope.$apply();

                if($scope.onChange)
                  $scope.onChange();
            });
        }
    };
});


/**
*
*  Base64 encode / decode
*  http://www.webtoolkit.info
*
**/
window.Base64 = {

    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="

    // public method for encoding
    , encode: function (input)
    {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length)
        {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2))
            {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3))
            {
                enc4 = 64;
            }

            output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        } // Whend 

        return output;
    } // End Function encode 


    // public method for decoding
    ,decode: function (input)
    {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length)
        {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64)
            {
                output = output + String.fromCharCode(chr2);
            }

            if (enc4 != 64)
            {
                output = output + String.fromCharCode(chr3);
            }

        } // Whend 

        output = Base64._utf8_decode(output);

        return output;
    } // End Function decode 


    // private method for UTF-8 encoding
    ,_utf8_encode: function (string)
    {
        var utftext = "";
        string = string.replace(/\r\n/g, "\n");

        for (var n = 0; n < string.length; n++)
        {
            var c = string.charCodeAt(n);

            if (c < 128)
            {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048))
            {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else
            {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        } // Next n 

        return utftext;
    } // End Function _utf8_encode 

    // private method for UTF-8 decoding
    ,_utf8_decode: function (utftext)
    {
        var string = "";
        var i = 0;
        var c, c1, c2, c3;
        c = c1 = c2 = 0;

        while (i < utftext.length)
        {
            c = utftext.charCodeAt(i);

            if (c < 128)
            {
                string += String.fromCharCode(c);
                i++;
            }
            else if ((c > 191) && (c < 224))
            {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else
            {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        } // Whend 

        return string;
    } // End Function _utf8_decode 

}

if (!String.prototype.splice) {
  /**
   * {JSDoc}
   *
   * The splice() method changes the content of a string by removing a range of
   * characters and/or adding new characters.
   *
   * @this {String}
   * @param {number} start Index at which to start changing the string.
   * @param {number} delCount An integer indicating the number of old chars to remove.
   * @param {string} newSubStr The String that is spliced in.
   * @return {string} A new string with the spliced substring.
   */
  String.prototype.splice = function(start, delCount, newSubStr) {
      return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
  };
}

String.prototype.ellipsis = function (maxLength) {
  if (this.length <= maxLength) {
    return this.toString();
  }
  return this.slice(0, maxLength - 3) + '...';
};


// WEBPACK FOOTER //
// ./src/js/app.js